// extracted by mini-css-extract-plugin
module.exports = {"main":"Divider_main__Vn7xW"};